import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "../../API/apiServices";
import credential from "../../API/Credentials.json";

export const submitContactQuery = createAsyncThunk(
  "contact/contactFooterQueryForm",
  async ({ apiData }, { rejectWithValue }) => {
    try {
      const apiMethod = credential?.request?.post;
      const endpoint = credential?.Query_API?.end_point;
      const response = await apiRequest(apiMethod, endpoint, apiData);
      if (response && response.success) {
        return response;
      } else {
        return rejectWithValue(response?.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const ContactSlice = createSlice({
  name: "contact",
  initialState: {
    loading: false,
    errors: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitContactQuery.pending, (state) => {
        state.loading = true;
        state.errors = null;
      })
      .addCase(submitContactQuery.fulfilled, (state) => {
        state.loading = false;
        state.errors = null;
      })
      .addCase(submitContactQuery.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      });
  },
});

export default ContactSlice.reducer;
